import React, { useRef, useState, useEffect } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Basic_Info_Offcan.css";

import Blue_Btn from "../../../../common/common_btn/blue_btn/Blue_Btn";
import Gray_Btn from "../../../../common/common_btn/gray_btn/Gray_Btn";
import Common_Back_Btn from "../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  GetProfile,
  UserUpdate,
} from "../../../../features/admin/Profile/Slice";
import Success_Toster from "../../../../common/common_modal/success_toster/Success_Toster";

const Basic_Info_Offcan = ({ show, handleClose }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const [profileImg, setProfileImg] = useState(
    "/assets/images/header/profile/user1.png",
  );

  const profile = useSelector((state) => state.profile);

  // fetch profile on open
  useEffect(() => {
    if (show) {
      dispatch(GetProfile());
    }
  }, [show, dispatch]);

  // react-hook-form setup
  const {
    register,
    reset,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  // Reset form when profile data updates
  useEffect(() => {
    if (profile?.data) {
      reset(profile.data); // direct reset using backend data
      if (profile.data.image)
        setProfileImg(process.env.REACT_APP_IMG_URL + profile.data.image); // set profile image if available
    }
  }, [profile?.data, reset]);

  // Handle file upload for profile pic
  const handlePlusClick = () => {
    fileInputRef.current.click();
  };

  const [profileFile, setProfileFile] = useState(null);
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith("image/")) return;

    const previewUrl = URL.createObjectURL(file);
    setProfileImg(previewUrl);
    setProfileFile(file); // ✅ store file to send in formData
  };
  const [success, setSuccess] = useState(false);
  // Submit handler (you can connect API update here)
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("email", data.email);
      formData.append("contact_no", data.contact_no);
      formData.append("name", data.name);
      if (profileFile) {
        formData.append("image", profileFile);
      }
      const res = await dispatch(UserUpdate({ data: formData }));

      // console.log("res.payload.response.data.errors",res.payload.errors)

      if (res.meta.requestStatus === "fulfilled") {
        setSuccess(true);
        dispatch(GetProfile());
        setTimeout(() => {
          setSuccess(false);
          handleClose();
        }, 2000);
      } else {
        if (res.payload?.errors) {
          setError("name", {
            type: "server",
            message: res.payload.errors,
          });
        }
        // setShowError(res.payload.errors);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Offcanvas
      className="Basic_Info_Offcan common_offcanvas Profile_Offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn backText="Basic Information" />
          </div>
        </Offcanvas.Title>

        {/* <div className="profile_top_div">
          <div className="pro_pic_div">
            <img src={profileImg} className="pro_img" alt="profile" />
          </div>
          <div className="plus_icon_div" onClick={handlePlusClick}>
            <FontAwesomeIcon icon={faPlus} className="plus_icon" />
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div> */}

        <div className="profile_top_div">
          <div className="pro_pic_div">
            <img src={profileImg} className="pro_img" alt="profile" />
          </div>
          <div className="plus_icon_div" onClick={handlePlusClick}>
            <FontAwesomeIcon icon={faPlus} className="plus_icon" />
          </div>

          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange} // ✅ calls handleFileChange
          />
        </div>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <div className="body_div">
          <Form
            className="add_form all_tabs_holder"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Form.Group className="form_group">
              <Form.Label>User ID</Form.Label>
              <Form.Control type="text" {...register("unique_id")} disabled />
            </Form.Group>

            <Form.Group className="form_group">
              <Form.Label>Designation / Role</Form.Label>
              <Form.Control type="text" {...register("role_name")} disabled />
            </Form.Group>

            <Form.Group className="form_group">
              <Form.Label>Full Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Full Name"
                {...register("name", {
                  required: "Full Name is required",
                })}
              />

              {errors?.name && (
                <Form.Text className="text-danger">
                  {errors.name.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group">
              <Form.Label>Contact No.</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Contact No"
                maxLength={10}
                {...register("contact_no", {
                  required: "Contact No is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Contact No must be exactly 10 digits",
                  },
                })}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
              />

              {errors?.contact_no && (
                <Form.Text className="text-danger">
                  {errors.contact_no.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="form_group">
              <Form.Label>Email</Form.Label>

              <Form.Control
                type="email"
                placeholder="Enter Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                  },
                })}
              />

              {errors?.email && (
                <Form.Text className="text-danger">
                  {errors.email.message}
                </Form.Text>
              )}
            </Form.Group>

            <div className="offcanvas_footer">
              <p className="bold_text">Edit Profile:</p>
              <p className="simple_text">
                Would you like to make changes to your details?
              </p>

              <div className="btn_div">
                {/* <Gray_Btn btnText={"Cance"} onClick={handleClose} /> */}
                <Blue_Btn btnText={"Edit"} type="submit" />
              </div>
            </div>
          </Form>
        </div>
      </Offcanvas.Body>

      {success && <Success_Toster successText="User Updated Successfully!" />}
    </Offcanvas>
  );
};

export default Basic_Info_Offcan;
